import { Popover } from "bootstrap";

let activePopover = null;
let activeVariant = null;

function closeActive() {
  if (activePopover) {
    activePopover.hide();
    activePopover = null;
  }
  if (activeVariant) {
    activeVariant.classList.remove("is-active");
    activeVariant = null;
  }
}

export function initVariantPopovers() {
  const varElements = document.querySelectorAll(".single-variant");

  varElements.forEach((variant) => {
    variant.addEventListener("click", (e) => {
      e.preventDefault();

      closeActive(); // chiude popover e rimuove is-active dal precedente

      const urlImg = variant.dataset.source;
      variant.setAttribute(
        "data-bs-content",
        `<button type="button" class="popover-close-btn" style="display:block;position: absolute;
  right: -9%;
  top: -12px;margin-left:auto;background:#fff;border:1px solid #e0e0e0;border-radius:50%;padding:2px 8px;cursor:pointer;font-size:.85rem;line-height:1.4">&times;</button><img src="${urlImg}">`
      );

      const pop = Popover.getOrCreateInstance(variant, {
        trigger: "manual",
        html: true,
        allowList: {
          ...Popover.Default.allowList,
          button: ["type", "class", "style"],
        },
      });

      pop.show();
      activePopover = pop;

      variant.classList.add("is-active"); // aggiunge is-active al cliccato
      activeVariant = variant;
    });
  });

  // Click sul pulsante chiudi o fuori → chiude popover e rimuove is-active
  document.addEventListener("click", (e) => {
    if (e.target.closest(".popover-close-btn")) {
      closeActive();
      return;
    }
    if (!e.target.closest(".single-variant") && !e.target.closest(".popover")) {
      closeActive();
    }
  });
}
